import {fetchWithState, getFetchedJSON, fetchWithStateBjorn} from '~/misc/fetch';
import toLegacyLoad from '~/misc/toLegacyLoad';
import { dataFormat } from '../misc/booking';

const markCreatedAt = () => {
  const searchSince = new Date();
  return (item) => {
    const createdAt = item.created_at || (searchSince - item.age);
    return toLegacyLoad(item, createdAt);
  };
};

export const saveOrHideOrViewLoads = (getState, checkedArr, type) => {
  const data = {
    shipment_id: checkedArr.join(','),
    status: type,
  };
  return fetchWithState(getState, {
    url: '/tl/loads',
    method: 'POST',
    body: data,
  }, false).then(getFetchedJSON);
};

export const getLoads = (getState, type) => {
  const data = {
    location: {
      lat: 0,
      lng: 0,
    },
    status: type,
  };
  return fetchWithState(getState, {
    url: '/tl/myloads',
    method: 'POST',
    body: data,
  }, false).then(getFetchedJSON).then((response) => ({
    shipments: response.data && response.data.filter(item => item).map(markCreatedAt()),
  }));
};

export const getBookingLoads =  (getState) => {
  return fetchWithStateBjorn(getState, {
    url: '/v2/bookings/list',
    method: 'GET',
  }, false).then(getFetchedJSON).then(res => {
    return {
      shipments: res.data && res.data.map(item => {
        return dataFormat(item);
        // return dataFormat(item)
      }).map(markCreatedAt()),};
  });
}

export const getBidLoads =  (getState) => {
  return fetchWithState(getState, {
    url: '/tl/bids/myjobs/list?page=0&pageSize=1000',
    method: 'GET',
  }, false).then(getFetchedJSON).then((res)=> ({
    shipments: res.data && res.data.resultList && res.data.resultList.map(item => ({...item.shipment, deletedByBroker: item.isLoadDeleted})).map(markCreatedAt()),
  }))
}

export const specialLoadsVerify = (getState, id, source) => {
	return fetchWithState(getState, {
		url: `/tl/booking/verification/check?source=${source}&brokerId=${id}`,
		method: 'POST',
	}, false).then(getFetchedJSON);
}


// WEBPACK FOOTER //
// ./src/api/loads.js